import React from 'react';
import styled from '@emotion/styled';
import { LIGHT_COLOR } from './ThemeIFProfs';

const Col = styled.div`
  ${props => {
    if (props.isHiddenForXs) {
      return 'display: none;';
    }
    return 'display: block;';
  }};
  @media (min-width: ${props => props.theme.tablet}){
    ${props => {
      if (props.isHiddenForXs) {
        return 'display: block;';
      }
      if (props.isHiddenForMd) {
        return 'display: none;';
      }
    }};
  }
  ${props => (props.justify ? 'text-align: ' + props.justify + ';' : null)}
  ${props => {
    if (!props.xs || props.xs === 'auto') {
      return 'max-width: 100%; flex-grow: 1;';
    }
    return (
      'max-width: ' +
      props.xs * 100 +
      '%; flex-grow: 0; flex-shrink: 0; flex-basis: ' +
      props.xs * 100 +
      '%;'
    );
  }}
  padding-left: ${props => (props.noGutters ? '0' : '.75rem')};
  padding-right: ${props => (props.noGutters ? '0' : '.75rem')};
  font-family: ${props => props.theme.mainFont};
  text-align: ${props =>
    props.insideAlignment ? props.insideAlignment : 'left'};
  margin-bottom: ${props => (props.marginBottom ? '1rem' : '0')};
  @media (min-width: ${props => props.theme.tablet}){
    ${props => {
      if (!props.md || props.md === 'auto') {
        return 'max-width: 100%; flex-basis: auto; flex-grow: 1;';
      }
      return (
        'min-width: ' +
        props.md * 100 +
        '%; flex-shrink: 0; flex-grow: 0; flex-basis: auto; width: ' +
        props.md * 100 +
        '%;'
      );
    }};
    ${props =>
      props.widthAutoMd
        ? 'flex-basis: auto !important; flex-grow: 0 !important;'
        : null};
    ${props =>
      props.insideAlignmentForMd
        ? 'text-align: ' + props.insideAlignmentForMd + ';'
        : null}
    ${props => (props.orderForMd ? 'order: ' + props.orderForMd + ';' : null)}
  }
  ${props =>
    props.widthAuto
      ? 'flex-basis: auto !important; flex-grow: 0 !important;'
      : null};
`;
const BackgroundColor = styled.div`
  background-color: ${props => {
    if (props.isCard) {
      return props.theme[LIGHT_COLOR];
    }
    if (props.backgroundColor) {
      return props.theme[props.backgroundColor];
    }
    return 'transparent';
  }};
  height: 100%;
  ${props =>
    props.verticalStretch
      ? 'display: flex; flex-direction: column; justify-content: space-between;'
      : null};
  ${props =>
    props.verticalCenter
      ? 'display: flex; flex-direction: column; justify-content: center;'
      : null};
  padding-top: ${props => (props.paddingTop ? '1rem' : '0')};
  padding-right: ${props => (props.paddingRight ? '1rem' : '0')};
  padding-bottom: ${props => (props.paddingBottom ? '1rem' : '0')};
  padding-left: ${props => (props.paddingLeft ? '1rem' : '0')};
  border: ${props => {
    if (props.debug) {
      return 'dotted 1px #888';
    }
    if (props.isCard && !props.noBorder) {
      return 'solid 1px ' + props.theme.formFieldsBorderColor;
    }
    return 'none';
  }};
  color: ${props => (props.color ? props.theme[props.color] : 'inherit')};
`;
class GridColumn extends React.Component {
  render() {
    return (
      <Col
        noGutters={this.props.noGutters}
        xs={this.props.xs}
        md={this.props.md}
        justify={this.props.justify}
        insideAlignment={this.props.insideAlignment}
        insideAlignmentForMd={this.props.insideAlignmentForMd}
        widthAuto={this.props.widthAuto}
        widthAutoMd={this.props.widthAutoMd}
        isHiddenForXs={this.props.isHiddenForXs}
        isHiddenForMd={this.props.isHiddenForMd}
        marginBottom={this.props.marginBottom}
        isCard={this.props.isCard}
        orderForMd={this.props.orderForMd}
        marginTopForXs={this.props.marginTopForXs}
      >
        <BackgroundColor
          backgroundColor={this.props.backgroundColor}
          verticalStretch={this.props.verticalStretch}
          verticalCenter={this.props.verticalCenter}
          isCard={this.props.isCard}
          paddingTop={this.props.paddingTop}
          paddingRight={this.props.paddingRight}
          paddingBottom={this.props.paddingBottom}
          paddingLeft={this.props.paddingLeft}
          color={this.props.color}
          noBorder={this.props.noBorder}
          debug={this.props.debug}
        >
          {this.props.children}
        </BackgroundColor>
      </Col>
    );
  }
}

export default GridColumn;
